import type { FaireProductEntity } from "../../entity_types/product";

export const p_caepkc3ekv: FaireProductEntity = {
  token: "p_caepkc3ekv",
  type: "product",
  name: "Ocean Tide Kitchen Towel",
  brandName: "Michaelian Home/India Overseas Traders, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/b230eb0299304a4c1763c5499dc273d0d5dd38ad9f163a8c75b3b165b4f6a752.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8d139eb927427413bde2f07eabb184999eb3d6be5d86c15af994e1e5a0c4fe46.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
